import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/common/DashboardBits";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin } from "lucide-react";

export default function ManagerTerritory() {
  const { user } = useAuth();
  const [mgr, setMgr] = useState(null);
  useEffect(() => {
    if (!user?.entity_id) return;
    api.get(`/managers/${user.entity_id}`).then((r) => setMgr(r.data));
  }, [user?.entity_id]);
  return (
    <div>
      <PageHeader title="My Territory" subtitle="Pincodes assigned by admin (read-only)" />
      <Card className="border border-slate-200 max-w-3xl">
        <CardContent className="p-6">
          <div className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-3">Approved pincodes ({(mgr?.allowed_pincodes || []).length})</div>
          {mgr && (mgr.allowed_pincodes || []).length === 0 && (
            <p className="text-sm text-red-500">No pincodes assigned yet. Please contact the admin to assign your territory.</p>
          )}
          <div className="flex flex-wrap gap-2">
            {(mgr?.allowed_pincodes || []).map((p) => (
              <span key={p} className="inline-flex items-center gap-1 px-3 py-1 bg-slate-100 rounded-full text-sm num" data-testid={`territory-pin-${p}`}>
                <MapPin className="h-3 w-3 text-slate-500" /> {p}
              </span>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
